module.exports = __webpack_public_path__ + "img/note_active.0b1b678b.svg";